import "swiper/css/bundle";
import Swiper, {
  Navigation,
  Pagination,
  EffectFade,
  Scrollbar,
  FreeMode,
  Mousewheel,
  Thumbs,
} from "swiper";
const zeroPad = (num, places) => String(num).padStart(places, "0");

// stop youtube videos inside dom element
function stopYoutubeVideo(element) {
  const videoIframes = element.querySelectorAll("iframe");
  if (videoIframes.length) {
    videoIframes.forEach((iframe) => {
      iframe.ytPlayer && iframe.ytPlayer.pauseVideo();
    });
  }
}

export default function initCarousel() {
  const narrowGalleryswiper = new Swiper(".gallery-narrow", {
    direction: "horizontal",
    loop: true,
    touchStartPreventDefault: false,
    modules: [Navigation, Pagination],

    pagination: {
      el: ".gallery-narrow-pagination",
      type: "fraction",
      formatFractionCurrent: function (number) {
        return zeroPad(number, 2);
      },
      formatFractionTotal: function (number) {
        return zeroPad(number, 2);
      },
    },

    navigation: {
      nextEl: ".gallery-narrow-next",
      prevEl: ".gallery-narrow-prev",
    },

    on: {
      slideChange: function (swiper) {
        stopYoutubeVideo(swiper.slides[swiper.realIndex]);
      },
    },
  });

  const galleries = document.querySelectorAll(".block-gallery");
  galleries.forEach((galleryBlock) => {
    const gallerySwiperElement = galleryBlock.querySelector(".gallery");

    const galleryOptions = {
      direction: "horizontal",
      loop: true,
      modules: [Navigation, Pagination, Thumbs],
      touchStartPreventDefault: false,

      pagination: {
        el: galleryBlock.querySelector(".gallery-pagination"),
        type: "fraction",
        formatFractionCurrent: function (number) {
          return zeroPad(number, 2);
        },
        formatFractionTotal: function (number) {
          return zeroPad(number, 2);
        },
      },

      navigation: {
        nextEl: galleryBlock.querySelector(".gallery-next"),
        prevEl: galleryBlock.querySelector(".gallery-prev"),
      },

      on: {
        slideChange: function (swiper) {
          stopYoutubeVideo(swiper.slides[swiper.realIndex]);
        },
      },
    };

    if (gallerySwiperElement) {
      const gallerySwiper = new Swiper(gallerySwiperElement, galleryOptions);

      const galleryThumnails = galleryBlock.querySelectorAll(
        ".gallery-thumbnails a"
      );
      const galleryModal = galleryBlock.querySelector(".modal");

      if (galleryThumnails && galleryThumnails.length > 0) {
        galleryThumnails.forEach((thumnailLink, index) => {
          thumnailLink.addEventListener(
            "click",
            (e) => {
              gallerySwiper.slideTo(index + 1, 0, false);
            },
            false
          );
        });
      }
      if (galleryModal) {
        document.body.appendChild(galleryModal);
      }
    }
  });

  const fadeSwiper = new Swiper(".swiper-fade", {
    direction: "horizontal",
    loop: true,
    watchOverflow: true,
    modules: [Navigation, Pagination, EffectFade],
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },

    on: {
      beforeInit: function (swiper) {
        const slidesCount =
          swiper.wrapperEl.querySelectorAll(".swiper-slide").length;
        swiper.el.classList.toggle("swiper-disabled", slidesCount <= 1);
        swiper.params.loop = slidesCount > 1 ? true : false;
      },
    },

    pagination: {
      el: ".swiper-fade-pagination",
      type: "fraction",
      formatFractionCurrent: function (number) {
        return zeroPad(number, 2);
      },
      formatFractionTotal: function (number) {
        return zeroPad(number, 2);
      },
    },

    navigation: {
      nextEl: ".swiper-fade-next",
      prevEl: ".swiper-fade-prev",
    },
  });

  let mobileScrollSwiper = null;
  function initmobileScrollSwiper() {
    let tablet = window.matchMedia("(min-width: 768px)");

    // destroy on desktop
    if (tablet.matches) {
      if (mobileScrollSwiper) {
        mobileScrollSwiper.destroy();
        mobileScrollSwiper = null;
      }
      return;
    }

    // enable on mobile
    if (!mobileScrollSwiper) {
      mobileScrollSwiper = new Swiper(".swiper-scroll-sm", {
        direction: "horizontal",
        slidesPerView: "auto",
        modules: [Scrollbar],

        scrollbar: {
          el: ".swiper-scroll-scrollbar",
        },
      });
    }
  }
  const mobileSwiperElement = document.querySelector(".swiper-scroll-sm");
  if (mobileSwiperElement) {
    initmobileScrollSwiper();
    window.addEventListener("resize", initmobileScrollSwiper, false);
  }

  const scrollSwiper = new Swiper(".swiper-scroll", {
    direction: "horizontal",
    slidesPerView: "auto",
    modules: [Scrollbar, Mousewheel, Navigation],
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: ".swiper-scroll-scrollbar",
    },
    navigation: {
      nextEl: ".swiper-cover-next",
      prevEl: ".swiper-cover-prev",
    },
  });

  // scrolling content
  const scrollableSwiper = new Swiper(".swiper-scrollable-timeline", {
    direction: "horizontal",
    slidesPerView: "auto",
    modules: [Scrollbar, FreeMode, Mousewheel],
    freeMode: {
      enabled: true,
      sticky: false,
    },
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      draggable: true,
      el: ".swiper-scroll-scrollbar",
    },
  });

  // scrolling content
  const maskEl = document.querySelector(".revenue-mask");
  const scrollableHistorySwiper = new Swiper(".swiper-scrollable-history", {
    direction: "horizontal",
    slidesPerView: "auto",
    passiveListeners: false,
    modules: [Scrollbar, FreeMode, Mousewheel, Navigation],
    /*freeMode: {
      enabled: true,
      sticky: false,
    },*/
    /* mousewheel : {
      forceToAxis: true
    },*/
    navigation: {
      nextEl: ".swiper-cover-next",
      prevEl: ".swiper-cover-prev",
    },
    /*
    scrollbar: {
      draggable: true,
      el: '.swiper-scroll-scrollbar',
    },*/

    on: {
      progress: function (swiper, progress) {
        if (maskEl) {
          const percent = 100 - progress * 100;
          maskEl.style.width = percent + "%";
        }
      },

      setTransition: function (swiper, transition) {
        maskEl.style.transitionDuration = transition + "ms";
      },
    },
  });

  let tabsScrollSwiper = null;
  function initTabsScrollSwiper() {
    let tablet = window.matchMedia("(min-width: 768px)");

    // destroy on desktop
    if (tablet.matches) {
      if (tabsScrollSwiper) {
        tabsScrollSwiper.destroy();
        tabsScrollSwiper = null;
      }
      return;
    }

    // enable on mobile
    if (!tabsScrollSwiper) {
      tabsScrollSwiper = new Swiper(".swiper-tabs", {
        direction: "horizontal",
        slidesPerView: "auto",
        modules: [FreeMode, Mousewheel],
        freeMode: {
          enabled: true,
          sticky: false,
        },
        mousewheel: {
          forceToAxis: true,
        },
      });
    }
  }
  const tabsSwiperElement = document.querySelector(".swiper-tabs");
  if (tabsSwiperElement) {
    initTabsScrollSwiper();
    window.addEventListener("resize", initTabsScrollSwiper, false);
  }
}
